import PropertyInstanceAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyInstanceAppResource";
import {store} from "../../index";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
import {PROPERTY_INSTANCE} from "../../helpers/variables";
import PropertyInstanceSearchRepository from "../../fixtures/PropertyInstanceSearchRepository";
import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';

export default {
    mixins: [ShowNotificationMixin],
    data() {
        return {
            propertyInstanceAppResourceSearch: new PropertyInstanceSearchRepository(),
        };
    },
    methods: {
        async getPropertyInstance(isFavorite = false) {
            const propertyNotFound = await this.noPropertyInstanceFound();
            if (propertyNotFound) {
                return await this.createPropertyInstance(isFavorite);
            }

            return this.propertyInstanceAppResourceSearch.appResourceCollection.getFirst();
        },

        async createPropertyInstance(isFavorite = false) {
            const propertyInstanceAppResource = new PropertyInstanceAppResource({
                attributes: {
                    name: this.getPropertyName(),
                    ownerUserUuid: store.getters.authUser.uuid,
                    organizationUuid: store.getters.getOrganizationUuid,
                    workspaceUuid: store.getters.getWorkspaceUuid,
                    propertyUuid: this.propertyAppResource.uuid,
                    ...(isFavorite && {isFavorite: true}),
                }
            });
            try {
                await propertyInstanceAppResource.save();
            } catch (e) {
                this.showNotification({
                    message: 'Something went wrong. Please try again later',
                    type: 'error'
                });
                console.error(e);
            }
            return propertyInstanceAppResource;
        },

        async noPropertyInstanceFound() {
            await this.fetchPropertyInstance();

            return !this.propertyInstanceAppResourceSearch.appResourceCollection.toArray().length;
        },

        async fetchPropertyInstance() {
            if (!(this.propertyAppResource || {}).uuid) return;
            this.propertyInstanceAppResourceSearch.setSearchData({
                limit: 1,
                filter: new ApiFilter({
                    params: {
                        propertyUuid: this.propertyAppResource.uuid,
                        workspaceUuid: store.getters.getWorkspaceUuid,
                    },
                })
            }, false);
            try {
                await this.propertyInstanceAppResourceSearch.search();
            } catch (e) {
                this.showNotification({
                    message: 'Something went wrong. Please try again later',
                    type: 'error'
                });
                console.error(e);
            }
        },

        getPropertyName() {
            if (
                this.propertyAppResource.addresses &&
                this.propertyAppResource.addresses instanceof AppResourceCollection &&
                this.propertyAppResource.addresses.toArray().length
            ) {
                return this.propertyAppResource.addresses.getFirst().fullAddress;
            } else {
                return PROPERTY_INSTANCE.DEFAULT_NAME;
            }
        }
    }
};
